import * as React from 'react';

import {Button} from 'shells/button/button';
// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from 'shells/icon/svg/loading-icon';

import styles from './report-empty-view.module.css';

type ReportEmptyViewProps = {
    hasError: boolean;
    isLoading: boolean;
    errorText: string;
    emptyText: string;
    onErrorRetry: () => any;
};

/**
 * Component representing the empty/loading/error state of a report view
 */
export class ReportEmptyView extends React.Component<ReportEmptyViewProps> {
    static defaultProps = {
        emptyText: 'Nothing was found.',
        errorText: 'Oh no! Something went wrong.',
    };

    render() {
        if (this.props.isLoading) {
            return (
                <div className={styles['container-loading']}>
                    <LoadingIcon className={styles['loading-icon']} />
                </div>
            );
        }

        if (this.props.hasError) {
            return (
                <div className={styles.container}>
                    <img src='/include/images/reports/saved-reports-error_2x.png' />
                    <h3 className={styles['empty-text']}>{this.props.errorText}</h3>
                    <Button onClick={this.props.onErrorRetry} variant='secondary' size='big'>
                        Try again
                    </Button>
                </div>
            );
        }

        return (
            <div className={styles.container}>
                <img src='/include/images/reports/saved-reports-empty_2x.png' />
                <h3 className={styles['empty-text']}>{this.props.emptyText}</h3>
            </div>
        );
    }
}
